import { FC } from "preact/compat";
import { useSignal } from "@preact/signals";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { TooltipContentProps, TooltipTriggerProps } from "./interfaces";
import cn from "classnames";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip: FC<TooltipPrimitive.TooltipProps> = ({
    open,
    onOpenChange,
    ...props
}) => {
    void open;
    void onOpenChange;

    const isOpen = useSignal<boolean>(false);
    return (
        <TooltipPrimitive.Root
            open={isOpen.value}
            onOpenChange={(state) => (isOpen.value = state)}
            {...props}
        />
    );
};

const TooltipTrigger: FC<TooltipTriggerProps> = ({ ...props }) => {
    return <TooltipPrimitive.Trigger {...props} />;
};

const TooltipContent: FC<TooltipContentProps> = ({
    className,
    sideOffset = 4,
    ...props
}) => (
    <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
            "animate-tooltip-animate-in transition-all data-[state=closed]:animate-tooltip-animate-out",
            "bg-gradient-decor-to-r z-50 overflow-hidden rounded-md px-3 py-1.5 text-xs text-white shadow-lg",
            className,
        )}
        {...props}
    />
);

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
